<template>
  <div class="news">
    <el-button type="primary" @click="openDialog()">新增</el-button>

    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="序号" width="180"></el-table-column>
      <el-table-column prop="title" label="新闻标题" width="180"></el-table-column>
      <el-table-column prop="Img" label="图片">
        <template slot-scope="scope">
          <img style="width:100%" :src="imgurl + scope.row.imgId" alt />
        </template>
      </el-table-column>
      <el-table-column prop="intro" label="新闻简介">
        <template slot-scope="scope">
          <p v-if="scope.row.intro.length > 100">{{scope.row.intro.substring(0,100)}} ...</p>
          <p v-else>{{scope.row.intro}}</p>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="type" label="新闻类别">
        <template slot-scope="scope">{{scope.row.type == 1 ? '公司新闻':'行业动态'}}</template>
      </el-table-column> -->
      <el-table-column prop="showHomeFlag" label="首页显示">
        <template slot-scope="scope">{{scope.row.showHomeFlag ? '是':'否'}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-arrow-up"
            @click="removeSort(scope.row, 0)"
          ></el-button>
          <el-button
            type="primary"
            icon="el-icon-arrow-down"
            @click="removeSort(scope.row, 1)"
          ></el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  -->
    <el-dialog title="新闻编辑" :visible.sync="dialogFormVisible">
      <el-form :model="formData">
        <el-form-item label="新闻标题" :label-width="formLabelWidth">
          <el-input v-model="formData.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新闻图片" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            :action="imgurl"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <img v-if="formData.imgId != 0" :src="imgurl+formData.imgId" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="新闻简介" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="10" v-model="formData.intro" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新闻内容" :label-width="formLabelWidth">
          <template>
            <editor v-model="formData.content" height="1300px" :border="true" />
          </template>
        </el-form-item>
        <!-- <el-form-item label="新闻类别" :label-width="formLabelWidth">
          <el-radio v-model="formData.type" :label="1">公司新闻</el-radio>
          <el-radio v-model="formData.type" :label="2">行业动态</el-radio>
        </el-form-item> -->
        <el-form-item label="首页显示" :label-width="formLabelWidth">
          <el-radio v-model="formData.showHomeFlag" :label="true">是</el-radio>
          <el-radio v-model="formData.showHomeFlag" :label="false">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateOrModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Editor from "../../components/Editor";
export default {
  name: "loginNews",
  components: {
    Editor, // 注册组件
  },
  data() {
    return {
      options: {},
      headers: {},
      tableData: [],
      formData: {
        id: 0,
        title: "",
        imgId: "",
        showHomeFlag: false,
        type: 1,
        content: "",
        intro: "",
      },
      dialogFormVisible: false,
      formLabelWidth: "120px",
      loading: true
    };
  },
  mounted() {
    let token = "Browser " + sessionStorage.getItem("token");
    //window.console.log(token);
    this.options = {
      headers: {
        Authorization: token
      }
    };
    this.headers = {
      Authorization: token
    };

    this.loadData();
  },
  methods: {
    handleSuccess(response, file, fileList) {
      // window.console.log(response, file, fileList);
      if (response && response.code == 0) {
        this.formData.imgId = response.data.fileId;
      } else {
        this.$message({
            message: response.msg || '系统异常',
            type: "error"
          });
      }
    },
    loadData() {
      this.loading = true;
      this.http
        .get("/basic/news/list")
        .then(response => {
          // window.console.log(response);
          this.tableData = response.data;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          this.$message({
            message: "网络或程序异常！" + e,
            type: "error"
          });
        });
    },
    openDialog() {
      // 清除数据
      this.formData.id = 0;
      this.formData.title = "";
      this.formData.imgId = '';
      this.formData.showHomeFlag = false;
      this.formData.type = 1;
      this.formData.content = "";
      this.formData.intro = "";

      this.dialogFormVisible = true;
    },
    handleCreateOrModify() {
      let params = { ...this.formData };
      params.content = this.reverseConvertEditorContent(params.content);
      if (!this.formData.id) {
        this.loading = true;
        this.http
          .post("/basic/news", params, this.options)
          .then(res => {
            window.console.log(res);
            this.loading = false;
            this.$message({
              message: "创建成功！",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.loadData();
          })
          .catch(e => {
            this.loading = false;
            this.$message({
              message: e,
              type: "error"
            });
          });
      } else {
        this.loading = true;
        this.http
          .put(`/basic/news/${this.formData.id}`, params, this.options)
          .then(response => {
            this.loading = false;
            // window.console.log(response);
            this.$message({
              message: "修改成功！",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.loadData();
          })
          .catch(e => {
            this.loading = false;
            this.$message({
              message: "网络或程序异常！" + e,
              type: "error"
            });
          });
      }
    },
    //编辑
    handleEdit(index, row) {
      //index:第几行   row:这一行的数据
      window.console.log(index, row);
      this.formData = { ...row }
      this.formData.content = this.convertEditorContent(this.formData.content);
      this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该新闻, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 已确认删除
          // 调接口删除
          this.loading = true;
          this.http
            .delete(`/basic/news/${row.id}`, null, this.options)
            .then(response => {
              this.loading = false;
              window.console.log(response);
              this.$message({
                message: "删除成功！",
                type: "success"
              });
              this.loadData();
            })
            .catch(e => {
              this.loading = false;
              this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    removeSort(row, removeOption) {
      this.loading = true;
      this.http
        .put(`/basic/news/removeSort/${row.id}/${removeOption}`, null, this.options)
        .then(response => {
          this.loading = false;
          // this.$message({
          //   message: "移动成功！",
          //   type: "success"
          // });
          this.loadData();
        })
        .catch(e => {
          this.loading = false;
          this.$message({
            message: e,
            type: "error"
          });
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.el-table {
  margin-top: 20px;
  button {
    padding: 10px;
  }
}
</style>